import { computed } from 'vue'
import stores from '../stores'

export const configWebMessageSpecial = computed(() => {
  let setting = stores.getStoresData().setting?.find(
    (setting: { key: string }) => setting.key === 'config_web_message_special'
  )

  return setting?.value || ''
})
